/* eslint-disable react-hooks/exhaustive-deps */
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Chip, Grid, Skeleton, Typography } from "@mui/material";
import clsx from "clsx";
import {
  CancelIconWrapper,
  ChipContainer,
  ItemAvatar,
  MasterListItem,
  cancelIconClasses,
  masterListItemclasses,
} from "./styles";

/**
 * @param {Object} props
 * @param {Object} props.item item to display
 * @param {String} props.index index of the item in the list
 * @param {Boolean} props.selected if item is selected
 * @param {Object} props.masterWrapping Input additionnal style Optionnal
 * @param {Boolean} props.isSkeleton if item is a skeleton (charging item)
 * @param {Boolean} props.hasAvatar if item has a avatar
 * @param {Boolean} props.isDeletable if item is deletable
 * @param {Function} props.onClick function onClick of parent component (MasterContainer)
 * @param {Function} props.onRemove function onRemove of parent component (MasterContainer)
 */
export default function MasterListItemDefault(props) {
  const {
    item,
    index,
    selected,
    masterWrapping,
    isSkeleton,
    hasAvatar,
    onClick,
    onRemove,
    isDeletable,
    isArchived,
    role,
    ...rest
  } = props;

  // on click function
  const onClickItem = () => {
    if (!isSkeleton && onClick) {
      onClick();
    }
  };

  const onClickTrashItem = (e) => {
    e.stopPropagation();
    if (!isSkeleton && isDeletable && onRemove) {
      onRemove();
    }
  };

  let display = {};
  if (isSkeleton) {
    display = {
      avatar: <Skeleton animation="wave" variant="circular" width="100%" height="100%" />,
      title: <Skeleton anation="wav" height={10} width="80%" sx={{ mb: 0.75 }} />,
      action: null,
      subTitle: <Skeleton anation="wav" height={10} width="80%" sx={{ mb: 0.75 }} />,
      description: <Skeleton anation="wav" height={10} width="80%" sx={{ mb: 0.75 }} />,
    };
  } else {
    display = {
      avatar: item[masterWrapping.title] ? item[masterWrapping.title][0] : "",
      title:
        typeof masterWrapping.title === "function"
          ? masterWrapping.title(item)
          : item[masterWrapping.title] || "(Sans Titre)",
      action: (
        <CancelIconWrapper
          role="deleteBtn"
          aria-label="close"
          onClick={onClickTrashItem}
          className={clsx({
            [cancelIconClasses.selected]: selected,
          })}
        >
          <DeleteOutlinedIcon color="primary" />
        </CancelIconWrapper>
      ),
      subTitle:
        typeof masterWrapping.subTitle === "function"
          ? masterWrapping.subTitle(item)
          : item[masterWrapping.subTitle] || " ",
      description:
        typeof masterWrapping.description === "function"
          ? masterWrapping.description(item)
          : item[masterWrapping.description] || " ",
    };
  }

  return (
    <MasterListItem
      className={clsx({
        [masterListItemclasses.selected]: selected,
        [masterListItemclasses.archived]: isArchived,
      })}
      onClick={() => onClickItem()}
      role={role || "menuitem"}
    >
      <Grid
        container={true}
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {hasAvatar && (
          <Grid sx={{ textAlign: "center" }} size={2}>
            <ItemAvatar aria-label="recipe">{display.avatar}</ItemAvatar>
          </Grid>
        )}
        <Grid
          container
          direction="column"
          sx={{
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
          size="grow">
          <Grid
            container={true}
            wrap={"wrap"}
            sx={{
              alignItems: "center",
            }}
            size={12}>
            <Grid size={isDeletable ? 10 : 12}>
              <Typography variant="body1" sx={{ mb: 1.25 }} className="itemTitle" noWrap>
                {display.title}
              </Typography>
            </Grid>
            {!isArchived && isDeletable && (
              <Grid
                container
                sx={{
                  justifyContent: "flex-end",
                }}
                size={2}>
                {display.action}
              </Grid>
            )}
          </Grid>
          <Grid container>
            <Typography className="itemSubtitle" variant="subtitle1" color="textSecondary" noWrap>
              {display.subTitle}
            </Typography>
          </Grid>
          <Grid container>
            <Typography className="itemDescription" variant="subtitle2" color="textSecondary" noWrap>
              {display.description}
            </Typography>
          </Grid>
          <ChipContainer>{isArchived && <Chip label="archivé" className={masterListItemclasses.chip} />}</ChipContainer>
        </Grid>
      </Grid>
    </MasterListItem>
  );
}
